.search-bar__form {
  @include from-search-bar;
  z-index: var(--z-index-form-search-bar, 1);
}
.search-bar__cancel {
  z-index: var(--z-index-form-search-bar, 1);
}

.guided__no-scroll {
  overflow: hidden;
}

.guided-host__input-active {
  @media (max-width: 720px) {
    position: unset;
    padding: 0;
    top: 0;
  }
}

uiaas-guided-search div.guided-pane {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  max-height: 90vh;
  overflow: auto;
  z-index: var(--z-index-guided-pane, 25);
  padding-top: 16px;
  @media (min-width: 720px) {
    top: calc(100% + 12px);
    padding-top: 0;
    border-radius: var(--qds-control-border-radius, 4px);
    box-shadow: 0 2px 5px rgb(98 100 105 / 50%);
  }

  &.guided-pane--hidden-no-data,
  &.guided-pane--hidden-no-focus {
    display: none;
  }

  ul {
    list-style-type: none;
    padding-inline-start: 0;
    margin-bottom: 0;
  }

  p {
    margin-block-start: 0;
    margin-block-end: 0;
  }

  .guided-keyboard-selected {
    background: #e6e6e6;
  }

  .guided-pane__suggestions-label,
  .guided-pane__search-history-section-label,
  .guided-pane__quick-links-toplabel {
    color: #626469;
    font-size: 16px;
    padding: 8px 12px;

    @media (max-width: 720px) {
      background-color: #f7f7f7;
      line-height: 25px;
      padding: 7px 16px;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
    }
  }

  .guided-pane__suggestions,
  .guided-pane__quick-links {
    a {
      text-decoration: none;
      border: 1px solid transparent;
    }

    span.highlight {
      font-weight: normal;
    }
  }

  .guided-pane__quick-links-image {
    float: left;
    width: 50px;
  }

  .guided-pane__quick-links-section-item {
    clear: both;
  }

  .guided-pane__suggestion-link,
  .guided-pane__quick-link {
    display: block;
    font-size: 18px;
    color: #333333;
    font-weight: 700;
    padding: 8px 12px;
    @media (min-width: 720px) {
      font-size: 16px;
    }
  }

  .guided-pane__search-history {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    text-align: left;
    display: block;
    padding: 8px 12px;
  }

  .guided-pane__suggestion-link:hover {
    @media (hover) {
      background: #e6e6e6;
    }
  }

  .guided-pane__quick-link:hover {
    @media (hover) {
      .guided-pane__quick-link-p {
        text-decoration: underline !important;
      }
    }
  }

  .guided-pane__suggestion-container,
  .guided-pane__quick-link-container {
    display: flex;
  }

  .guided-pane__suggestion-p,
  .guided-pane__quick-link-p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    line-height: 22px;
  }

  .guided-pane__search-history-p {
    @extend .guided-pane__quick-link-p;
    margin-right: 20px;
  }

  .guided-pane__quartz-icon-wrapper {
    margin-right: 4px;
    padding-top: 1px;
    display: flex;
    align-items: center;
    svg {
      width: 20px;
      height: 20px;
    }
  }

  .guided-pane__quick-links-section-label {
    font-size: 14px;
    line-height: 20px;
    color: #626469;
    padding: 4px 12px;
    @media (max-width: 720px) {
      line-height: 25px;
      padding: 7px 16px;
    }
  }

  .guided-pane__quick-link-description {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #626469;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-top: 6px;
  }

  .guided-pane__quick-link-status {
    color: #626469;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-right: 0.5em;
  }

  /*
    autocorrection text should be:
        color: #9FA0A4;
        font-size: 14px !important;
        padding-bottom: 5px !important;
    */

  .guided-pane__suggestion-chips {
    //contains all chips for given slot (beforeTitle/afterTitle)
    display: inline-block;
  }

  .guided-pane__suggestion-chip {
    //a single chip
    display: inline-block;
    color: white;
    background-color: var(--qds-theme-signature-color-default, #008a16);
    padding: 0 4px;
    border-radius: 2px;
    margin: 1px 4px 1px 0;
    font-weight: 400;
  }

  //this is just a sample, class is taken from cssClass property of a chip
  .guided-chip-custom__secondary {
    //background-color: black;
    background-color: #9fa0a4;
    color: white;
  }

  .guided-pane__chip-label {
    margin-right: 4px;
  }

  .guided-pane__suggestion-text,
  .guided-pane__quick-link-text {
    margin-right: 4px;
  }

  .guided-pane__see-all-results-item {
    min-height: 40px;
    border-top: 1px solid
      var(--srp-greyscale-super-light-gray-e-6-e-6-e-6, #e6e6e6);
    background: var(--srp-greyscale-100-background-fafafa, #fafafa);
    list-style-type: none;
  }

  .guided-pane__see-all-results-link {
    display: flex;
    float: right;
    height: 40px;
    padding: 8px 12px;
    align-items: center;
    gap: 4px;
    cursor: pointer;
  }

  .guided-pane__see-all-results-link-text {
    color: var(--website-link-srp-specific-cta, #1a0dab);
  }

  .guided-pane__see-all-results-link-text:hover {
    color: var(--website-link-srp-specific-cta, #1a0dab);
    text-decoration: underline;
  }

  .guided-pane__see-all-results-link-icon {
    margin-left: 4px;
  }

  .guided-pane__search-history-section-label {
    font-size: 14px;
    line-height: 20px;
    color: #626469;
    padding: 12px;
    margin-top: 8px;
    @media (max-width: 720px) {
      line-height: 25px;
      padding: 7px 16px;
    }
  }

  .guided-pane__search-history-section-item:hover {
    @media (hover) {
      background: #e6e6e6;
    }
  }

  .guided-pane__search-history-section-item {
    clear: both;
    display: flex;
    align-items: center;
  }

  .guided-pane__search-history-p {
    margin-right: 15px;
    display: -webkit-box;
    line-clamp: 2;
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
    display: -webkit-box;
  }
}

.guided__backdrop {
  visibility: hidden;
  position: fixed;
  top: -100px;
  left: 0;
  width: 120vw;
  height: calc(100vh + 100px);
  background: white;
  z-index: var(--z-index-backdrop, 1);

  @media (min-width: 720px) {
    background: #333333;
    opacity: 0.7;
  }
}

.guided__backdrop--visible {
  visibility: visible;
}

uiaas-guided-search.guided-sdl-v1.mm-is-open {
  .guided__backdrop {
    background: white;
    opacity: 1;
    @media (min-width: 1200px) {
      background: #333333;
      opacity: 0.7;
    }
  }

  @media (max-width: 1200px) {
    div.guided-pane {
      right: -10px;
      left: -10px;
      top: 53px;
      padding-top: 10px;
      box-shadow: none;
    }
    .guided__backdrop {
      //position: absolute;
      top: 50px;
      left: -20px;
    }
    .guided-pane__suggestions-label,
    .guided-pane__quick-links-toplabel {
      background-color: #f7f7f7;
      line-height: 25px;
      padding: 7px 16px;
      border-top: 1px solid #e6e6e6;
      border-bottom: 1px solid #e6e6e6;
    }
  }
}

.backdrop-fix {
  position: relative;
  z-index: 1;
}

uiaas-guided-search div.guided-pane[dir="rtl"] {
  .guided-pane__quartz-icon-wrapper {
    margin-right: 0px;
    margin-left: 4px;
  }
}

/*Different theming options for link highlighting, applied as a class to <uiaas-guided-search>*/
uiaas-guided-search {
  position: relative;
  // regarding different highlighting options, check:
  // https://stackoverflow.com/questions/5687035/css-bolding-some-text-without-changing-its-containers-size
  &.no-highlighting {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      font-weight: normal;
      color: black;
    }
  }

  &.highlighting2 {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      text-shadow: 0 0 0 currentColor;
      font-weight: normal;

      span.highlight {
        text-shadow: none;
      }
    }
  }

  &.inverted-highlighting {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      text-shadow: none;
      font-weight: normal;

      span.highlight {
        text-shadow: 0 0 0 currentColor;
      }
    }
  }

  &.inverted-highlighting2 {
    div.guided-pane .guided-pane__suggestion-link,
    div.guided-pane .guided-pane__quick-link {
      text-shadow: none;
      font-weight: normal;

      span.highlight {
        text-shadow: 1px 0 1px currentColor;
      }
    }
  }

  &.single-line-clamp {
    .guided-pane__suggestion-p,
    .guided-pane__quick-link-p {
      -webkit-line-clamp: 2;
      line-clamp: 2;
      line-clamp: 2;
    }
  }
}

uiaas-guided-search {
  div.guided-pane {
    @media (max-width: 720px) {
      right: -10px;
      left: -10px;
      top: 110px;
      padding-top: 10px;
    }
  }
  @media (max-width: 720px) {
    .guided__backdrop {
      //position: absolute;
      top: 120px;
      left: -20px;
    }
  }
}

uiaas-guided-search.guided-sdl-v1 {
  div.guided-pane {
    @media (max-width: 720px) {
      top: 53px;
    }
  }
}
